import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseModalDirective } from 'src/app/shared/directives/base-modal.directive';
import { ModalButtonsComponent } from 'src/app/shared/components/modal-buttons/modal-buttons.component';
import { ModalCloseButtonComponent } from 'src/app/shared/components/modal-close-button/modal-close-button.component';

@Component({
  selector: 'cmv-cookies-modal',
  templateUrl: './cookies-modal.component.html',
  styleUrls: ['./cookies-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ModalButtonsComponent, ModalCloseButtonComponent],
})
export class CookiesModalComponent extends BaseModalDirective<boolean> {}
